import { CLEAR_SECTION } from "./constantes"

export const clearSection = () => {
    return {
        type: CLEAR_SECTION,
    }
}